import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { MeritPersonInsertRequest } from "./MeritPersonInsertRequest";
import { MeritPersonUpdateRequest } from "./MeritPersonUpdateRequest";

@Injectable()
export class DataService_Student_PBIS {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	GetMeritPersonInfo(PersonID, StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "PBIS/GetMeritPersonInfo?PersonID=" + PersonID + "&StartDate=" + StartDate + "&EndDate=" + EndDate;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadMerits(SchoolID) {
		var postResult$ = new Subject();
		var url = "PBIS/MeritSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritPersonInsert(parms: MeritPersonInsertRequest) {
		var postResult$ = new Subject();
		var url = "PBIS/MeritPersonInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritPersonUpdate(parms: MeritPersonUpdateRequest) {
		var postResult$ = new Subject();
		var url = "PBIS/MeritPersonUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MeritPersonDelete(MeritPersonID) {
		var postResult$ = new Subject();
		var url = "PBIS/MeritPersonDelete?MeritPersonID=" + MeritPersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
